import { useQuery } from '@tanstack/react-query'
import { LoanSearchCriteria } from '@matech/thebigpos-sdk'

import queryKeys from '../../../../services/queryKeys'
import type { PaginationParams } from '../../../../types'
import { TheBigPOSApi } from '../../../../lib/TheBigPOSClient'

type UsePipelineLoanDataProps = {
	userId?: string | null
	criteria: LoanSearchCriteria
	query?: PaginationParams
}

export type { LoanSearchCriteria }

const QUERY_STALE_TIME = 60 * 1000 * 5

function useLoanSearch({
	userId,
	criteria,
	query,
}: UsePipelineLoanDataProps) {
	const {
		isLoading,
		isRefetching,
		isError,
		data: result,
		refetch,
	} = useQuery({
		queryKey: [
			queryKeys.loans,
			userId,
			criteria.searchText,
			query?.pageSize,
			query?.pageNumber,
			query?.sortBy,
			query?.sortDirection,
		],
		queryFn: () => TheBigPOSApi.searchLoans(criteria, query),
		enabled: !!userId,
		refetchOnMount: false,
		staleTime: QUERY_STALE_TIME,
	})

	const isProgressPending = isLoading

	return {
		isRefetching,
		isProgressPending,
		isError,
		data: result?.data?.rows || [],
		totalRows: result?.data.count,
		refetch,
	}
}

export default useLoanSearch
